import { render } from "./ModalVotacionMiss.vue?vue&type=template&id=22957984&scoped=true"
import script from "./ModalVotacionMiss.vue?vue&type=script&lang=js"
export * from "./ModalVotacionMiss.vue?vue&type=script&lang=js"

import "./ModalVotacionMiss.vue?vue&type=style&index=0&id=22957984&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22957984"]])

export default __exports__